export default {
  api: {
    name: {
      notNull: "Give your invoice line a name",
    },
  },
}
